import ServiceEvent from '../../Services/ServiceEvent';
import Service from '../../Services/Service';

const ProgramAPI = {
    getEventAll({tag, lang, page,sort, eventdate}) {
        let p = page ? page:1;
        if (sort === 'date') {
            return ServiceEvent.get(`/products/${tag}?page=${p}&lang=${lang}&sort=${sort}&eventdate=${eventdate}`);
        } else if (sort) {
            return ServiceEvent.get(`/products/${tag}?page=${p}&lang=${lang}&sort=${sort}`);
        } else {
            return ServiceEvent.get(`/products/${tag}?page=${p}&lang=${lang}`);
        }
    },
    getEventByPage({tag, page, sort, eventdate}) {
        let p = page ? page:1;
        if (sort === 'date') {
            return ServiceEvent.get(`/products/${tag}?page=${p}&sort=${sort}&eventdate=${eventdate}`);
        } else {
            return ServiceEvent.get(`/products/${tag}?page=${p}&sort=${sort}`);
        }
    },
    getEventById(id, lang) {
        return ServiceEvent.get(`/product/${id}?lang=${lang}`);
    },
    getRelatedEventById(id) {
        return ServiceEvent.get(`/related-product/${id}`);
    },
    getDesignWorldCalendar({ date, page, lang }) {
        // date like.. 2020-07
        page = page ? page : 1;
        date = date ? date : 'all';
        if (date === "all") {
            return Service.get(`/design_world_calendar_all?page=${page}&lang=${lang}`);
        } else {
            return Service.get(`/design_world_calendar_all?date=${date}&page=${page}&lang=${lang}`);
        }
    },
    getDesignCalendarById(id) {
        return Service.get(`/design_world_calendar/${id}`);
    },
    checkWidget(id){
        return Service.get(`/zipEventWidget/${id}`);
    }
}
export default ProgramAPI
